import { BootConfig } from 'types';

const mockBootConfig: BootConfig = {
  isMock: true,
  authInfo: {
    featureFlags: {},
    idLoggedInWebuser: '1',
    permissions: {
      manageToolPermissions: ['LTI13_MANAGE_PLATFORM'],
      canManagePlatform: true,
      canCreateLinks: true,
      canModifyLinks: true,
      canReadLinks: true,
      isReadonlyLinks: false,
      hasLTI13PaicePermission: false,
    },
  },
  ltiManagementBaseUrl: '/',
  ltiServiceApiProxyBaseUri: '/api/ltiservice',
  ltiHandlerServiceBaseUrl:
    'https://intv2-ltihandlerservice-eastus2.azurewebsites.net/',
  useNoLayout: false,
};

const rootDatasetProps =
  document.getElementById('spaRootContainer')?.dataset.customProps;

const bootConfig = rootDatasetProps
  ? (JSON.parse(rootDatasetProps) as BootConfig)
  : mockBootConfig;

export default bootConfig;
